import { http } from '../api/client';

export const notificationService = {
    getUnreadCount: () => http.get('/notifications/unread-count'),
    getNotifications: (params) => http.get('/notifications', { queryParams: params }),
    markAsRead: (id) => http.post('/notifications/read', { id }),
    markAllAsRead: () => http.post('/notifications/read-all', {}),
};
